import {useState,useEffect,useRef} from "react";
import {Link} from "react-router-dom";
/* -- biz9 import start -- */
import {Str,Log} from "biz9-utility";
import {Message,Type,Url,Field,Title} from "../../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,User,Template,Storage,System} from "../../../../project";
import {Data_Logic} from "biz9-data-app";
import {Page_Logic,Portal_Type,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Data,Portal_Remote_CMS,Portal_Table,Portal_Field} from "biz9-portal-app";
/* -- biz9 import end -- */
const Modal_Item_Add = (props) => {
    const [val_sub_page_title,setValSubPageTitle] =  useState('Add ' + Str.get_table_by_name(props.table,{plural:true}));
	const [val_title,setValTitle] = useState("Item " + Str.get_id());
	useEffect(() => {
			},[props]);
	const updateValTitle = (event) => {
        // -- post-item-title, post-title --
		setValTitle(event.target.value);
	};
	async function post_item_field(value){
        // -- post-item-field --
        if(!value){
            value = '';
        }
		if(value.trim() === '') {
			props.toast_error(Message.INPUT_REQUIRED);
		}else{
			//add
			props.toast_loading(Message.SAVING);
			let item_new = Data_Logic.get(props.table,0,
					{data:{
						title:Str.get_trim(value),
						title_url:Str.get_title_url(Str.get_trim(value)),
						setting_visible:"1",
					}});
					let [response,data] = await Portal_Remote_Data.post(App.get_url(Portal_Url.DATA_POST),props.table,item_new);
					props.onUpdate(data);
					props.toast_dismiss();
					props.toast_success(response.message);
				}
			};
return (
		<>
		{/* Add Item */}
		<div className="modal new-modal fade" id="add_item" data-keyboard="false" data-backdrop="static">
		<div className="modal-dialog modal-dialog-centered">
		<div className="modal-content">
		<div className="modal-header">
		<button type="button" className="close-btn" data-bs-dismiss="modal">
		<span>×</span>
		</button>
		</div>
		</div>
		</div>
		</div>
		{/* /Add Item */}
		{/* Item */}
		<div className="modal new-modal fade" id="withdraw" data-keyboard="false" data-backdrop="static">
		<div className="modal-dialog modal-dialog-centered">
		<div className="modal-content">
		<div className="modal-header">
		<button type="button" className="close-btn" data-bs-dismiss="modal">
<span>×</span>
</button>
</div>
<div className="modal-body">
<div className="row">
<div className="col-md-12">
<div className="amt-wrap">
<div className="settings-card-head bg-light" style={{marginBottom:'15px'}} >
            <h4>{val_sub_page_title}</h4>
</div>
<div className="form-wrap">
<label className="form-label">
Title
<span className="text-danger ms-1">*</span>
</label>
<input value={val_title} onBlur={() => post_item_field(val_title)} onChange={updateValTitle} type="text" className="form-control" />
</div>
</div>
</div>
<div className="col-md-12">
<Link to="#"  data-bs-dismiss="modal" className="btn btn-primary w-100">
{Title.LABEL_CLOSE}
</Link>
</div>
</div>
</div>
</div>
</div>
</div>
{/* /Item */}
</>
);
};
export default Modal_Item_Add;
